import { Box } from '@chakra-ui/react';
import './App.css';
import { MainRoutes } from './Navigation/main_navigation/MainRoutes';

function App() {
  return (
// test commit
    <Box height={"100vh"}>
      <MainRoutes />
    </Box>

  );
}

export default App;
